var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653",
    transform: "translate(-135 -3614)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(135 3614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cloud-storage-iot-scalable-computing-weather-svgrepo-com",
    transform: "translate(140.484 3622.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10700",
    "data-name": "Path 10700",
    d: "M24.714,25.259a8.252,8.252,0,0,0,.96-15.91,8.38,8.38,0,0,0-16.7.926A8.172,8.172,0,0,0,9.5,13.15a6.383,6.383,0,0,0-1.217-.116,6.207,6.207,0,1,0,0,12.413S19.154,25.535,24.714,25.259Z",
    transform: "translate(1.516 1.883)",
    fill: "#b0e4c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10698",
    "data-name": "Path 10698",
    d: "M14.8,8.453a.308.308,0,0,0,0-.2.771.771,0,0,0-.9-.617,33.243,33.243,0,0,1-3.349.551.771.771,0,0,0,0,1.52h0l1.586-.22L10.11,12.33a.749.749,0,0,0,.595,1.256.793.793,0,0,0,.595-.264l2.2-2.8.132,1.124a.771.771,0,1,0,1.52-.176c-.176-1.63-.352-2.908-.352-2.908Z",
    transform: "translate(8.545 3.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10699",
    "data-name": "Path 10699",
    d: "M12.088,14.161l-1.542.375,1.961-2.776a.749.749,0,0,0-.176-1.08.771.771,0,0,0-1.08.176L9.268,13.764a5.9,5.9,0,0,0-.242-1.1.749.749,0,0,0-.9-.573.771.771,0,0,0-.595.9c.352,1.564.529,2.776.529,2.82a.727.727,0,0,0,0,.308.793.793,0,0,0,.749.551h.22a21.486,21.486,0,0,1,3.393-1.013.771.771,0,0,0-.33-1.5Z",
    transform: "translate(5.551 7.685)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsupport);
export default __webpack_public_path__ + "static/media/cloudsupport.0d962bbb879c981557f431e242cc7d4c.svg";
export { ForwardRef as ReactComponent };